import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/constants';
// Ressources
import withGlobalStyles from '../../../utils/global-styles';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { FormatType, HeadCell } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';

interface PartnersListProps extends WithTranslation {
    globalClasses: any;
}

class PartnersListPage extends React.Component<PartnersListProps> {
    canWriteSettings: boolean = UserUtils.checkRights({
        name: AccountRight.PARTNER_SETTINGS,
        mode: RightRank.W,
    });

    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            createCell(t, Cell.NAME),
            createCell(t, Cell.CREATION_DATE, { type: FormatType.DateShort }),
        ];
        return headers;
    };

    renderFAB = (): JSX.Element => {
        const { t, globalClasses } = this.props;
        return (
            this.canWriteSettings && (
                <>
                    <br />
                    <br />
                    <Fab
                        className={globalClasses.fabBotRight}
                        size="large"
                        component={RouterLink}
                        to={paths.partnersAdd}
                        color="secondary"
                        aria-label={t('common:add')}
                    >
                        <AddIcon />
                    </Fab>
                </>
            )
        );
    };

    render() {
        const { t } = this.props;

        return (
            <App
                disableBreadcrumb
                header={{
                    title: t('title'),
                    subtitle: t('description'),
                }}
            >
                <EnhancedTable headers={this.headerBuilder()} type={tableRequestPoints.PARTNERS} />
                {this.renderFAB()}
            </App>
        );
    }
}

export default withGlobalStyles(withTranslation(['partner', 'common'])(PartnersListPage));
